module.exports = __webpack_public_path__ + "img/0Q3A9771_L_Black.94ad321a.jpg";